module.exports = __webpack_public_path__ + "img/plus.68697ab5.svg";